
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: 'prestation',
    components: {},
    props: {
        prestations: Array,
        prestation_index: Number,
        montant_total: Number,
        detail_empty: {
            type: Boolean,
            default: false
        },
        detail_loading: {
            type: Boolean,
            default: false
        },
        detail_error: {
            type: Boolean,
            default: false
        },
        // Type des prestations et filtre de la liste : permettent de charger les patients à la demande
        // quand la liste a été chargée sans eux (with_patients: 0)
        data_type: {
            type: String,
            default: ''
        },
        filtre: {
            type: Object,
            default: () => ({})
        },
    },
    data() {
        return {
            fields: [
                { key: 'libelle', label: 'Libellé' }, { key: 'qte', label: 'Qté' },  'montant'
            ],
            fields_patient: [
                { key: 'num_dossier', label: 'N° dossier' }, 
                'patient', 'sexe', { key: 'telephone', label: 'Téléphone' },
                'qte', 'montant'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            liste_patients: [],
            modal_index: 0,
            patients_loading: false,
            patients_error: false,
            patients_request_id: 0,
        }
    },

    watch: {
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        viewPatient(data, index) {
            this.modal_index = index
            this.patients_error = false

            if (Array.isArray(data.patients)) {
                this.liste_patients = data.patients
                return
            }

            // Patients chargés à l'ouverture de la fenêtre, pour cette prestation uniquement
            const request_id = ++this.patients_request_id
            this.liste_patients = []
            this.patients_loading = true
            store_operation.getPatientsProduitCreance({ ...this.filtre, data_type: this.data_type, libelle: data.libelle }).then((patients) => {
                if (request_id != this.patients_request_id) return
                this.liste_patients = patients
                this.patients_loading = false
            }).catch(() => {
                if (request_id != this.patients_request_id) return
                this.patients_loading = false
                this.patients_error = true
            })
        },
    }
}


